<template>
  <registration-form :alert="alert" :privacy-policy-url="privacyPolicyUrl" :additionalFields="additionalFields"
    @submit="submit" />
</template>

<script>
import { mapMutations } from 'vuex'
import { Api } from '../api/apiAccess'
import RegistrationForm from '../components/RegistrationForm.vue'

export default {
  components: {
    RegistrationForm
  },

  data() {
    return {
      alert: {
        type: 'success',
        text: '',
        dismissible: false,
        isActive: false
      },
      privacyPolicyUrl: '',
      additionalFields: null
    }
  },

  async mounted() {

    var clubNumToCheck = this.$route.params.clubNumber;
    // check wheter the clubnumber in the url is set and if yes, check if the clubnumber is valid
    if (clubNumToCheck) {
      var clubLoginViewModel = { VereinsNummer: clubNumToCheck, Passwort: 'interessiert nicht', CvpSecret: 'interessiert noch weniger' };
      var clubNumberExists = (await Api.HaKuBu.haKuBuVereinsLogin(clubLoginViewModel)).data.LoginId != -2;
      console.log(clubNumberExists)
      if (!clubNumberExists) {
        this.$root.snackbar.show(this.clubNumNotFound());
        this.$router.push({ name: 'NotFound', params: { clubNumber: clubNumToCheck } });
        return;
      }
    } else {
      this.$root.snackbar.show(this.clubNumNotFound());
      this.$router.push({ name: 'NotFound' });
      return;
    }

    this.init()
  },

  computed: {
    clubNumber() {
      return this.$route.params['clubNumber']
    }
  },

  methods: {
    ...mapMutations({ updateClubData: 'UPDATE_CLUB_DATA' }),

    init() {
      const ep = Api.PeAn
        ep.peAnGetConfig(this.clubNumber).then(r => {
          if (!r.data.PeAnAktivieren || !r.data.CVPServicesAktivieren) {
            this.alert = {
              type: 'warning',
              text: this.$t('error.noAccess'),
              isActive: true
            }
          } else {
            this.additionalFields = r.data.AdditionalFields;
            this.getClubData()
          }
        }).catch(() => {
          this.$root.snackbar.show(this.invalidClubNum(this.clubNumber));
          this.$router.push({ name: 'NotFound' })
        })
    },
    invalidClubNum(clubNum) {
      return {
        message: this.$t("error.invalidClubNum", [clubNum]),
        color: "error",
        icon: "mdi-numeric-off",
        timeout: 2500,
      }
    },
    clubNumNotFound() {
      return {
        message: this.$t("error.clubNumNotFound"),
        color: "error",
        icon: "mdi-numeric-off",
        timeout: 2500,
      }
    },
    clubNumFound(clubNum) {
      return {
        message: this.$t("common.clubNumFound", [clubNum]),
        color: "success",
        icon: "mdi-numeric",
        timeout: 2500,
      }
    },

    getClubData() {
      const ep = Api.PublicData

      ep.publicDataGetClubData(150, 150, this.clubNumber).then(r => {
        this.updateClubData(r.data)
        this.privacyPolicyUrl = r.data.APP_DATENSCHUTZBESTURL
      }).catch(() => {
        this.alert = {
          type: 'warning',
          text: this.$t('error.noAccess'),
          isActive: true
        }
      })
    },

    submit(data) {
      data.item.clubNumber = this.clubNumber

      const ep = Api.ApiProxy

      ep.apiApiProxyProxyPostPost({
        'HCaptchaResponse': data.token,
        'ClubNumber': this.clubNumber,
        'Route': 'PeAn/CreateNewClubMembership',
        'RouteParameters': {},
        'BodyParameters': { response: '', addressData: data.item, additionalFields: data.additionalFields, pdf: data.pdf }
      }).then(r => {
        var responseCode = Number.parseInt(r.data.cvpApiResponse)
        if (responseCode === 0) {
          this.alert = {
            type: 'success',
            text: this.$t('registrationStatusCodes.code_0'),
            isActive: true,
            dismissible: true
          }
        } else {
          if (this.$te('registrationStatusCodes.code_' + responseCode)) {
            this.alert = {
              type: 'error',
              text: this.$t('registrationStatusCodes.code_' + responseCode),
              isActive: true,
              dismissible: true
            }
          } else {
            this.alert = {
              type: 'error',
              text: this.$t('registrationStatusCodes.unknown'),
              isActive: true,
              dismissible: true
            }
          }
        }
      })
    },

    alertDismissTimer() {
      setTimeout(() => {
        this.alert = {
          type: 'warning',
          text: '',
          isActive: false
        }
      }, 10000)
    }
  }
}
</script>